import CustomSwiper from '@/_application/core/components/ui/custom-swiper';
import UsefulInformationLoader from '@/_application/core/components/ui/loaders/useful-information-loader';
import {useCategoryPosts, useHomepagePosts} from '@/framework/useful-information';
import rangeMap from '@/lib/range-map';
import {SwiperSlide} from 'swiper/react';
import UsefulInformationHeader from './useful-information-header';
import UsefulInformationItem from './useful-information-item';
import {useEffect} from 'react';
import {Post} from '__generated__/__types__';
import {useRouter} from 'next/router';

interface IUsefulInformationProps {
    className?: string;
    categoryId?: number;
}

function UsefulInformation({className, categoryId}: Readonly<IUsefulInformationProps>) {
    const {
        fetchData: fetchHomepage,
        isLoading: isHomePageLoading,
        usefulInformation: homepagePosts,
        error: homepageError,
    } = useHomepagePosts();

    const {
        fetchData: fetchCategory,
        isLoading: isCategoryLoading,
        usefulInformation: categoryPosts,
        error: categoryError,
    } = useCategoryPosts();
    const router = useRouter();

    // component is using for homepage or category
    const isHomepage = router.asPath === '/';

    const viewAllLabel = isHomepage ? 'Xem thêm các bài viết hay' : 'Xem tất cả';
    const isLoading = isHomepage ? isHomePageLoading : isCategoryLoading;
    const usefulInformation = isHomepage ? homepagePosts : categoryPosts;
    const error = isHomepage ? homepageError : categoryError;

    const noUsefulInformation = (!isLoading && usefulInformation.length === 0) || error;

    useEffect(() => {
        if (isHomepage) {
            fetchHomepage();
        } else if (categoryId) {
            fetchCategory(categoryId);
        }
    }, []);

    if (!isHomepage && !categoryId) return <></>;
    if (noUsefulInformation) return <></>;

    return (
        <div className={className}>
            <UsefulInformationHeader viewAllLabel={viewAllLabel} />

            <div>
                {isLoading ? (
                    <div className="mt-1 grid grid-cols-4 gap-5">
                        {rangeMap(4, i => (
                            <UsefulInformationLoader key={i} uniqueKey={`product-${i}`} />
                        ))}
                    </div>
                ) : (
                    <CustomSwiper
                        className="mt-5 pb-4!"
                        hasNavigation
                        buttonPrevClassName="-left-4 top-[calc(50%-8px)]"
                        buttonNextClassName="-right-4 top-[calc(50%-8px)]"
                        breakpoints={{
                            1280: {
                                slidesPerView: 4.7,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 3.7,
                                spaceBetween: 16,
                            },
                            768: {
                                slidesPerView: 2.7,
                                spaceBetween: 12,
                            },
                        }}>
                        {usefulInformation?.map(
                            (item, index) =>
                                item?.__typename === 'Post' && (
                                    <SwiperSlide key={item?.id ? item?.id : index} className="cursor-pointer">
                                        <UsefulInformationItem usefulInformation={item as Post} />
                                    </SwiperSlide>
                                ),
                        )}
                    </CustomSwiper>
                )}
            </div>
        </div>
    );
}

export default UsefulInformation;
